/*
 * Copyright (c) Kalaora 2022.
 * Author: fharold
 *
 * hilo-oauth-manager
 * ApiHelper.ts
 */

import {AxiosResponse} from "axios";
import BadRequest from "./model/exception/BadRequest";
import Unauthorized from "./model/exception/Unauthorized";
import Forbidden from "./model/exception/Forbidden";
import NotFound from "./model/exception/NotFound";
import Timeout from "./model/exception/Timeout";
import Duplicate from "./model/exception/Duplicate";
import UnprocessableEntity from "./model/exception/UnprocessableEntity";
import InternalServerError from "./model/exception/InternalServerError";

export default class ApiHelper {
    public static handleAPIErrorIfNecessary<T>(response: AxiosResponse<T>) {
        if (response.status >= 400) {
            switch (response.status) {
                case 400:
                    throw new BadRequest("");
                case 401:
                    throw new Unauthorized("");
                case 402:
                    throw new Forbidden("");
                case 404:
                    throw new NotFound("");
                case 408:
                    throw new Timeout("");
                case 409:
                    throw new Duplicate("");
                case 422:
                    throw new UnprocessableEntity("");
                case 500:
                    throw new InternalServerError("");
            }
        }
    }
}
